import { Injectable } from '@angular/core';
import { Api } from '../providers/api/api';
import { Usuario } from '../entities/usuario';

@Injectable()
export class UsuarioDAO {

    constructor(private _api: Api) { }


    public signup(usuario: Usuario): Promise<any> {
        return new Promise((resolve, reject) => {
            this._api.post('Usuario', usuario).subscribe(res => {
                resolve(JSON.parse(res._body));
            }, error => {
                reject(error);
            });
        });
    }

    public alterarUsuario(usuario: Usuario): Promise<any> {
        return new Promise((resolve, reject) => {
            this._api.put('Usuario/AlterarUsuario', { usuario: usuario }).subscribe(res => {
                resolve(JSON.parse(res._body));
            }, error => {
                reject(error);
            });
        });
    }

    

    public login(usuario: Usuario): Promise<Usuario> {
        return new Promise((resolve, reject) => {
            this._api.get(`Usuario/Autenticacao/${usuario.NomeUsuario}/${usuario.Senha}`).subscribe(res => {
                if (res)
                    resolve(new Usuario().deserialize(JSON.parse(res._body)));

                reject('Usuário ou senha incorretos.');
            }, error => {
                reject(error);
            });
        });
    }

    public obterUsuarioDaEmpresa(idEmpresa: number): Promise<Usuario[]> {
        return new Promise((resolve, reject) => {
            let mecanicos: Usuario[] = [];

            this._api.get(`Usuario/Lista`).subscribe(res => {
                JSON.parse(res._body).forEach(element => {
                    mecanicos.push(new Usuario().deserialize(element));
                });

                resolve(mecanicos);
            }, error => {
                reject(error);
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/daos/usuario-dao.ts